export const validationMessages = {
  headerTitle: "Title is required.",
  headerParagraph: "Paragraph is required.",
  smallHeader: "Small header is required.",
};
